import {
  LOAD_AGENCY_PROFILE,
  LOAD_AGENCY_PROFILE_ERROR,
  LOAD_RECRUITER_REVIEWS,
  LOAD_APPLICANT_REVIEWS,
  LOAD_TEAM_MEMBERS,
  SUBMIT_UPDATE,
  SUBMIT_UPDATE_ERROR,
  SET_SPECIALITIES_FORM_LOADING,
  SET_QUALIFICATIONS_FORM_LOADING,
  SET_ABOUT_ME_FORM_LOADING,
  SET_USER_FORM_LOADING,
  SET_ABOUT_COMPANY_FORM_LOADING,
  SET_IMAGES_FORM_LOADING,
  SET_REVIEWS_LOADING,
  UPDATE_AVATAR,
  UPDATE_PROFILE_IMAGE,
  UPDATE_USER_DATA,
  REJECT_ENGAGEMENT,
  ACCEPT_ENGAGEMENT,
  SET_REJECT_ENGAGEMENT_LOADING,
  REJECT_ENGAGEMENT_ERROR,
  SET_ACCEPT_ENGAGEMENT_LOADING,
  ACCEPT_ENGAGEMENT_ERROR,
} from "../actions/types";

const initialState = {
  profileData: null,
  errors: {},
  loading: true,
  userFormLoading: false,
  specialitiesFormLoading: false,
  qualificationsFormLoading: false,
  aboutMeFormLoading: false,
  aboutCompanyFormLoading: false,
  imagesFormLoading: false,
  reviewsLoading: false,
  rejectEngagementLoading: false,
  acceptEngagementLoading: false,
  engagementActionTaken: false,
};

export default function agencyProfileReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_AGENCY_PROFILE:
      return {
        ...state,
        loading: false,
        profileData: payload,
        errors: {},
      };
    case UPDATE_USER_DATA:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          user: {
            ...state.profileData.user,
            ...payload,
          },
        },
        userFormLoading: false,
        errors: {},
      };
    case SUBMIT_UPDATE:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          ...payload,
        },
        specialitiesFormLoading: false,
        qualificationsFormLoading: false,
        aboutMeFormLoading: false,
        aboutCompanyFormLoading: false,
        errors: {},
      };
    case UPDATE_AVATAR:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          user: {
            ...state.profileData.user,
            ...payload,
          },
        },
        userFormLoading: false,
      };
    case SET_SPECIALITIES_FORM_LOADING:
      return {
        ...state,
        specialitiesFormLoading: true,
      };
    case SET_QUALIFICATIONS_FORM_LOADING:
      return {
        ...state,
        qualificationsFormLoading: true,
      };
    case SET_ABOUT_ME_FORM_LOADING:
      return {
        ...state,
        aboutMeFormLoading: true,
      };
    case SET_ABOUT_COMPANY_FORM_LOADING:
      return {
        ...state,
        aboutCompanyFormLoading: true,
      };
    case SET_USER_FORM_LOADING:
      return {
        ...state,
        userFormLoading: true,
      };
    case SET_IMAGES_FORM_LOADING:
      return {
        ...state,
        imagesFormLoading: true,
      };
    case SET_REVIEWS_LOADING:
      return {
        ...state,
        reviewsLoading: true,
      };
    case LOAD_AGENCY_PROFILE_ERROR:
    case SUBMIT_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
        formLoading: false,
        userFormLoading: false,
        specialitiesFormLoading: false,
        qualificationsFormLoading: false,
        aboutMeFormLoading: false,
        aboutCompanyFormLoading: false,
        imagesFormLoading: false,
      };
    case LOAD_RECRUITER_REVIEWS:
      return {
        ...state,
        loading: false,
        reviewsLoading: false,
        profileData: {
          ...state.profileData,
          employerReviews: payload.employerReviews,
          employerReviewsTotal: payload.employerReviewsTotal,
          employerAndApplicantReviewsTotal:
            payload.employerAndApplicantReviewsTotal,
        },
      };
    case LOAD_APPLICANT_REVIEWS:
      return {
        ...state,
        loading: false,
        reviewsLoading: false,
        profileData: {
          ...state.profileData,
          applicantReviews: payload.applicantReviews,
          applicantReviewsTotal: payload.applicantReviewsTotal,
        },
      };
    case LOAD_TEAM_MEMBERS:
      return {
        ...state,
        loading: false,
        profileData: {
          ...state.profileData,
          teamMembers: payload.teamMembers,
        },
      };
    case UPDATE_PROFILE_IMAGE: {
      return {
        ...state,
        profileData: {
          ...state.profileData,
          slides: [{ id: 0, url: payload.profileImageUrl }],
        },
        imagesFormLoading: false,
      };
    }
    case SET_REJECT_ENGAGEMENT_LOADING:
      return {
        ...state,
        rejectEngagementLoading: true,
      };
    case REJECT_ENGAGEMENT:
      return {
        ...state,
        rejectEngagementLoading: false,
        engagementActionTaken: true,
      };
    case REJECT_ENGAGEMENT_ERROR:
      return {
        ...state,
        rejectEngagementLoading: false,
      };
    case SET_ACCEPT_ENGAGEMENT_LOADING:
      return {
        ...state,
        acceptEngagementLoading: true,
      };
    case ACCEPT_ENGAGEMENT:
      return {
        ...state,
        acceptEngagementLoading: false,
        engagementActionTaken: true,
      };
    case ACCEPT_ENGAGEMENT_ERROR:
      return {
        ...state,
        acceptEngagementLoading: false,
      };
    default:
      return state;
  }
}
